import { Container, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Chart from "./chart2.png";
import Astro from "./astro.svg";

export default function Tokonomics() {
  const sectionHeading = "TOKENOMICS";
  return (
    <>
      <Box id="tokonomics">
        <Container>
          <Box sx={{ position: "relative", textAlign: "center" }} mb={10}>
            <Box>
              {" "}
              <span className="textStroke">
                <Typography
                  color="white"
                  fontSize={{ xs: "31px", sm: "50px", md: "74px" }}
                  sx={{ letterSpacing: "0.12em" }}
                >
                  {sectionHeading}
                </Typography>
              </span>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: "10%",
                right: 0,
                left: 0,
                margin: "auto",
              }}
            >
              <Typography
                color="white"
                fontSize={{ xs: "25px", sm: "40px", md: "64px" }}
                sx={{ letterSpacing: "0.12em" }}
              >
                {sectionHeading}
              </Typography>
            </Box>
          </Box>

          <Box>
            {" "}
            <img src={Chart} alt={Chart} width="100%" />{" "}
          </Box>
        </Container>
        <Box
          sx={{
            maxWidth: "1550px",
            width: "100%",
            position: "relative",
            textAlign: "right",
            margin: "auto",
          }}
        >
          <img src={Astro} alt={Astro} width="20%" />
        </Box>
      </Box>
    </>
  );
}
